import { Box, Button, Flex, Image, UnstyledButton } from "@mantine/core"
import { FC, PropsWithChildren } from "react"
import { Navigate, useNavigate } from "react-router-dom"
import AppFooter from "@components/navigation/AppFooter"
import styles from "./PageWithHeaderCloseButton.module.css"
import cPLogo from "@assets/svg/cp-logo.svg"
import { IconX } from "@tabler/icons-react"
import { useAuthContext } from "@context/AuthProvider"

export interface PageWithHeaderCloseButtonProps extends PropsWithChildren {
	onCloseClick?: () => void
	closeRoute?: string
}

export const PageWithHeaderCloseButton: FC<PageWithHeaderCloseButtonProps> = ({
	children,
	onCloseClick,
	closeRoute = "/login"
}) => {
	const { isAuthenticated } = useAuthContext()
	const navigate = useNavigate()

	if (isAuthenticated) {
		return <Navigate to="/home" replace />
	}

	const handleCloseClick = () => {
		if (onCloseClick) {
			onCloseClick()
		} else {
			navigate(closeRoute)
		}
	}

	return (
		<Flex className={styles.pageWrapper}>
			<Box className={styles.header}>
				<Flex justify="space-between" align="center" h="100%">
					<Box w={60} />

					<UnstyledButton
						onClick={() => navigate("/login")}
						aria-label="Navigate to CruisingPower login page"
					>
						<Image
							src={cPLogo}
							alt="Company Logo"
							w={{ base: 199, sm: 214 }}
							h={{ base: 28, sm: 31 }}
						/>
					</UnstyledButton>
					<Button
						c="var(--text-color-primary)"
						variant="transparent"
						size="md"
						p={0}
						leftSection={<IconX size={18} />}
						onClick={handleCloseClick}
					/>
				</Flex>
			</Box>

			<Box className={styles.pageContent}>{children}</Box>
			<AppFooter />
		</Flex>
	)
}
